import type { TesterImportApply, TesterImportPreview } from '@testflow/shared';
import { ApiError, BASE, assertAuthorized, request } from './api.js';

const base = (p: string, planId: string) => `/v1/projects/${p}/plans/${planId}/tester-import`;

export interface TesterImportApplyResult {
  updated: number;
  skipped: Array<{ test_case_id: string; reason: string }>;
}

export const testerImportApi = {
  // #131: Datei-Download über fetch + Blob — kein JSON, deshalb nicht request(). Derselbe
  // Session-Vertrag (401 → Login) über assertAuthorized.
  async downloadTemplate(projectId: string, planId: string, planName: string): Promise<void> {
    const path = `${base(projectId, planId)}/template`;
    const res = await fetch(`${BASE}${path}`, { credentials: 'include' });
    assertAuthorized(res, path);
    if (!res.ok) throw new ApiError(res.status, await res.text());
    const url = URL.createObjectURL(await res.blob());
    const a = document.createElement('a');
    a.href = url;
    a.download = `${planName}-tester.xlsx`;
    a.click();
    // Verzögert: Firefox bricht den Download ab, wenn die URL sofort nach click() freigegeben wird.
    setTimeout(() => URL.revokeObjectURL(url), 10_000);
  },
  // Multipart: den JSON-Content-Type von request() darf der Upload nicht setzen (Boundary).
  async preview(projectId: string, planId: string, file: File): Promise<TesterImportPreview> {
    const form = new FormData();
    form.append('file', file);
    const path = `${base(projectId, planId)}/preview`;
    const res = await fetch(`${BASE}${path}`, {
      method: 'POST',
      credentials: 'include',
      body: form,
    });
    assertAuthorized(res, path);
    if (!res.ok) throw new ApiError(res.status, await res.text());
    return res.json() as Promise<TesterImportPreview>;
  },
  apply: (projectId: string, planId: string, body: TesterImportApply) =>
    request<TesterImportApplyResult>(`${base(projectId, planId)}/apply`, {
      method: 'POST',
      body: JSON.stringify(body),
    }),
};
